<template>
  <section class="bottom" :id="bottomData.key">

    <div class="bottom__advantages">
      <div
        v-for="(advantage, i) in bottomData.advantages"
        :key="i"
        class="bottom__advantage"
        @click="getCall({ type: 'sale' })"
      >
        <img v-if="advantage.icon" class="bottom__advantage--img" :src="getAdvIcon(advantage.icon)" :alt="advantage.icon">
        <span class="bottom__advantage--text" v-html="advantage.text"></span>
      </div>
    </div>
    
      <div class="bottom__gifts">
        <p class="bottom__gifts--title">Более 10 подарков за покупку а/м</p>

        <div class="bottom__gifts--list list">
          <div class="list__item">
            <div
              v-for="(gift, index) in bottomData.gifts"
              :key="index"
              class="list__gift"
              @click="getCall({ type: 'sale' })"
            >
              <img :src="getGiftIcon(gift.icon)" :alt="gift.icon" class="list__gift--icon">
              <p class="list__gift--text" v-html="gift.text"></p>
            </div>
          </div>

          <div class="list__item gifts_list">
            <div
              v-for="(text, index) in bottomData.gifts_list"
              :key="index"
              v-html="text"
              class="list__gift"
              @click="getCall({ type: 'sale' })"
            >
            </div>
          </div>
        </div>
      </div>

      <car-buttons class="bottom__buttons" />
  </section>
</template>

<script>
import Mixin from "@/common/mixin";
import CarButtons from './car-buttons.vue';

export default {
  name: "bottom",
  props: ["bottomData"],
  mixins: [Mixin],
  components: { CarButtons },
  computed: {
    getAdvIcon: () => (icon) => {
      try {
        return require(`../../../images/icons/advantages/${icon}.svg`);
      } catch {
        return require(`../../../images/icons/advantages/${icon}.png`);
      }
    },
    getGiftIcon: () => (icon) => {
      try {
        return require(`../../../images/icons/gifts/${icon}.svg`);
      } catch {
        return require(`../../../images/icons/gifts/${icon}.png`);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/constants.scss";

.bottom {
  display: flex;
  flex-direction: column;
  margin-top: auto;
  background: #00000075;
  backdrop-filter: blur(5px);
  border-radius: 1.5em;
  padding: 1em 1.5em;
  box-shadow: inset 1px 1px 0 0 #cccccc; 

  &__advantages {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
    font-size: 1.34em;
    margin-bottom: 0.75em;
  }

  &__advantage {
    display: flex;
    align-items: center;
    gap: 0.4em;
    cursor: pointer;

    &--img {
      max-width: 1.8em;
    }
  }


  &__gifts {
    background: #fff;
    color: #000;
    border-radius: 8px;
    padding: 0.5em 0.6em 0.85em;
    width: max-content;
    box-shadow: 0px 0px 24px 0px #00000026;

    &--title  {
      font-size: 1.25em;
      font-weight: 700;
    }
  }

  .list {
    display: flex;
    margin-top: 0.6em;

    &__item {
      display: flex;
      flex-direction: column;
      gap: 0.8em;
      padding-left: 1em;

      &:not(:last-child) {
        border-right: 1px solid #000;
        padding: 0;
        padding-right: 1em;
      }
    }

    &__gift {
      display: flex;
      align-items: center;
      gap: 0.5em;
      font-size: 0.8em;
      padding-right: 1.43em;
      cursor: pointer;

      &--icon {
        max-width: 1.75em;
      }
    }
  }

  .gifts_list {
    justify-content: space-between;
    gap: 0.5em;
    font-size: 0.75em;

    :first-child {
      font-size: 1.25em;
      font-weight: 700;
      margin-bottom: 0.6em;
    }
  }

  &__buttons {
    display: none;
  }
}

@media (max-width: 800px) {
  .bottom  {
    margin-top: 0.5em;
    font-size: 1.1em;
    background: #00000080;

    &__buttons {
      display: flex;
    }
  }
}
</style>
